// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import ModuleBase from "#/common/ModuleBase";
import { ImageAspectRatio } from "#/components/image_aspect_ratio/ImageAspectRatio";
import { Headline } from "#/components/headline/Headline";
import { HighlightExpander } from "#/components/highlight_expander/HighlightExpander";
import { Store } from "../../../store";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ImageAspectRatio,
    Headline,
    HighlightExpander,
  },
})
export class ContentModule extends ModuleBase {
  getBackgroundColorFromInstance(instance: object) {
    return instance["section_color"]["color"];
  }

  get isHeadline() {
    return this.instance["section_text"]["headline"]["text"].length > 0;
  }

  get textColumnSize() {
    return parseInt(
      this.instance["section_position_columns"]["column_size_text"],
      10
    );
  }

  get mediaColumnSize() {
    return parseInt(
      this.instance["section_position_columns"]["column_size_image"],
      10
    );
  }

  get mediaAlignmentClass() {
    if (this.instance["section_position_columns"]["position"] == "left") {
      return "content-module--image-left";
    } else {
      return "content-module--image-right";
    }
  }

  public buttonTheme(type) {
    switch (type) {
      case "wb-e-btn-1":
        return "primary";
      case "wb-e-btn-2":
        return "default";
      case "wb-e-btn-3":
        return "inverted";
      case "button_outline":
        return "outline-secondary";
      case "button_outline_inverted":
        return "outline-inverted";
      default:
        return "default";
    }
  }

  get images() {
    if (this.instance["section_image"]["images"]) {
      return this.instance["section_image"]["images"].slice();
    } else {
      return [];
    }
  }

  get s3BaseUrl() {
    return this.$store.page.page!.s3Url;
  }

  get imageFormat() {
    return this.instance["image_format"]
      ? this.instance["image_format"]
      : "original";
  }

  public getVideoUrl(uploadUrl) {
    if (uploadUrl.split("/").length > 5) {
      return uploadUrl;
    } else {
      return Store.instance.page.page!.s3Url + uploadUrl;
    }
  }
}
